// App entry point v1.0.1
import { createRoot } from "react-dom/client";
import { 
  initializeFaro, 
  ReactIntegration, 
  getWebInstrumentations 
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { ErrorBoundary } from "@nimbitlabs/observability";
import App from "./App.tsx";
import "./index.css";

// Initialize Grafana Faro with full instrumentation
if (import.meta.env.VITE_GRAFANA_FARO_URL) {
  console.log('Initializing Grafana Faro:', import.meta.env.VITE_GRAFANA_FARO_URL);
  
  initializeFaro({
    url: import.meta.env.VITE_GRAFANA_FARO_URL,
    app: {
      name: 'hydranaut-client',
      version: import.meta.env.VITE_APP_VERSION || '1.0.0',
      environment: import.meta.env.MODE === 'production' 
        ? 'production'
        : import.meta.env.MODE === 'staging'
        ? 'staging'
        : 'development',
    },
    
    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation(),

      // React integration without router (we use standard BrowserRouter).
      new ReactIntegration(),
    ],
  });
  
  // Set user context when available
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      window.faro?.api.setUser({
        id: user.id,
        email: user.email,
        attributes: {
          accountId: user.accountId,
        },
      });
    }
  } catch (error) {
    console.error('Failed to set Faro user context:', error);
  }
} else {
  console.warn('Grafana Faro URL not set - logging disabled');
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
